import { render, staticRenderFns } from "./BrandingLogin.vue?vue&type=template&id=19af3972&"
import script from "./BrandingLogin.vue?vue&type=script&lang=ts&"
export * from "./BrandingLogin.vue?vue&type=script&lang=ts&"
import style0 from "./BrandingLogin.vue?vue&type=style&index=0&id=19af3972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports